export const frDate = new Intl.DateTimeFormat("fr-FR", { weekday: "short", day: "numeric", month: "short" });
export const frLongDate = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
export const frMonth = new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" });

export function dateFromKey(key: string): Date {
  return new Date(`${key}T12:00:00`);
}

export function formatDate(key: string, long = false): string {
  return (long ? frLongDate : frDate).format(dateFromKey(key));
}

export function formatMinutes(minutes: number): string {
  const sign = minutes < 0 ? "−" : "";
  const absolute = Math.abs(Math.round(minutes));
  return `${sign}${Math.floor(absolute / 60)} h ${String(absolute % 60).padStart(2, "0")}`;
}

export function todayKey(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}
